import { ReceiptText } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function VendorInvoicesPage() {
  return (
    <PhaseStubPage
      title="Vendor invoices"
      phase={2}
      modules={[
        'Invoice ingest (manual + email parse + QBO bill sync)',
        'Auto-match against open POs and GRs',
        'Variance / dispute workflow',
        'Push approved bills to QuickBooks for payment',
      ]}
      icon={ReceiptText}
    />
  );
}
